import { fromJS } from 'immutable';

// Constants
import { CONSTANTS } from './constants';

const initialState = fromJS({
    adminUsers: {
        isLoading: false,
        data: [],
        addOrEditModal: {
            isLoading: false,
            isShown: false,
            type: 'ADD',
            selectedUser: {}
        }
    }
});

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case CONSTANTS.ON_ADMIN_USERS_IS_LOADING:
            return state.setIn(['adminUsers', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_ADMIN_USERS_DATA:
            return state.setIn(['adminUsers', 'data'], payload.users);

        case CONSTANTS.ON_ADMIN_USERS_ADD_OR_EDIT_MODAL_IS_LOADING:
            return state.setIn(['adminUsers', 'addOrEditModal', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_ADMIN_USERS_ADD_OR_EDIT_MODAL_IS_SHOWN:
            return state.setIn(['adminUsers', 'addOrEditModal', 'isShown'], payload.isShown);

        case CONSTANTS.ON_ADMIN_USERS_ADD_OR_EDIT_MODAL_TYPE:
            return state.setIn(['adminUsers', 'addOrEditModal', 'type'], payload.modalType);

        case CONSTANTS.ON_ADMIN_USERS_ADD_OR_EDIT_MODAL_SELECTED_USER:
            return state.setIn(['adminUsers', 'addOrEditModal', 'selectedUser'], payload.selectedUser);

        default:
            return state;
    }
};

export default reducer;
